<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="custom-list">
    <div class="custom-list__col">
        <ul class="custom-list__box custom-list__box--available">
            <li (click)="toggleSelect(selectedList, item)" (keydown)="toggleSelect(selectedList, item)"
                *ngFor="let item of selectionItems; let i = index"
                [ngClass]="{
                    active: checkInList(selectedList, item) !== -1,
                    preselected: disabled || checkInList(preselectedDisabledItems, item) !== -1
                }"
                class="custom-list__item"
                id="item-{{ i }}"
            >
                {{ item[this.displayName] }}
            </li>
        </ul>
    </div>
</div>
